import styled from 'styled-components';
import * as Colors from '../../constants/colors';

export const H1 = styled.h1`
  color: ${Colors.primaryColor};
  font-weight: 200;
  font-size: 2em;
`;

export const H2 = styled.h2`
  color: ${Colors.primaryColor};
  font-weight: 600;
`;

export const H3 = styled.h3`
  color: ${Colors.primaryColor};
  font-weight: 600;
`;

export const H4 = styled.h4`
  color: ${Colors.primaryColor};
  font-weight: 600;
`;

export const H5 = styled.h5`
  color: ${Colors.primaryColor};
  font-weight: 600;
`;

export const SubH3 = styled.h3`
  color: ${Colors.textDarkColor};
  font-weight: 400;
`;

export const SubH4 = styled.h4`
  color: ${Colors.textDarkColor};
  font-weight: 600;
`;



// WEBPACK FOOTER //
// ./app/components/common/Heading.tsx